import cn from 'classnames';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/types/store-types';
import './styles.scss';

const Scrollbar: FC<React.ComponentPropsWithoutRef<'div'>> = ({ children, className, ...props }) => {
  const { sideBarMenuIsOpen } = useSelector((state: RootState) => state.app);
  const { generalConfigs } = useSelector((state: RootState) => state.configs);

  return (
    <div
      className={cn('custom-scrollbars__container ', {
        ['sidebar_is_open']: sideBarMenuIsOpen,
        ['sidebar']: generalConfigs?.hasSideBar,
      })}
    >
      <div className={cn('custom-scrollbars__content')} id="scroll_container" {...props}>
        {children}
      </div>
    </div>
  );
};

export default Scrollbar;
